import React, {useContext, useEffect} from 'react';
import {makeStyles, Theme, useTheme} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import {UnidadePageContext} from '../UnidadePageContext';
import UnidadeTabContent from './UnidadeTabContent';
import { Button } from '@material-ui/core';

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}


function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >

            <Box p={3} style={{display: value === index ? 'block' : 'none'}}>
                {children}
            </Box>

        </div>
    );
}

function a11yProps(index: any) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        width: '100%'
    },
  containerMargin:{

  }
}));

const UnidadeTab: React.FC = () => {
    const {model, loadUsuarios, buscarPorAutoescolaIdFinanceiro} = useContext(UnidadePageContext);
    const theme = useTheme();

    const isSM = window.innerWidth <= theme.breakpoints.values.sm;
    
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    useEffect(() => {
        setTimeout(() => {
            document.getElementById('tabs')?.scrollIntoView({behavior: 'smooth'})
        }, 50);
    }, [model])

    useEffect(() => {
        if (!model) {
            setValue(0)
            return;
        }

        let exist = model.unidades.find(x => x.id == value);
        if (exist) {
            return;
        }
        setValue(model.unidades[0].id)


    }, [model?.unidades])

    const handleChange = async (event: React.ChangeEvent<{}>, newValue: number) => {
        if (newValue === value) return;
        const unidade = model?.unidades.find(x => x.id === newValue);
        setValue(newValue);
        if (!unidade?.usuarios) {
            await loadUsuarios(unidade as any, true)
        }

    };

    return (
      <>
        {model && !!value && (
          <div className={classes.root}>
            <AppBar
              position="relative"
              variant="outlined"
              style={{
                width: "100%",
                display: "flex",
                flexDirection: isSM ? "column" : "row",
                justifyContent: "space-between",
                alignItems: isSM ? "start" : "center",
              }}
            >
              <Tabs
                id="tabs"
                value={value}
                onChange={handleChange}
                aria-label="simple tabs example"
              >
                {model.unidades.map((x) => (
                  <Tab
                    fullWidth
                    key={x.id}
                    label={x.id + " - " + x.nome}
                    value={x.id}
                    {...a11yProps(x.id)}
                  />
                ))}
              </Tabs>
              <Button
                variant="contained"
                size="small"
                color="secondary"
                style={{
                  height: 36,
                  marginRight: 8,
                  ...(isSM && { width: "100%", marginTop: 8, marginRight: 0 }),
                }}
                onClick={buscarPorAutoescolaIdFinanceiro}
              >
                Abrir financeiro
              </Button>
            </AppBar>
            {model.unidades.map((x) => (
              <TabPanel key={x.id} value={value} index={x.id}>
                <UnidadeTabContent state={model} unidadeCurrent={x} />
              </TabPanel>
            ))}
          </div>
        )}
      </>
    );
}

export default UnidadeTab;
